import { applyMiddleware, combineReducers, createStore } from "redux";
import { thunk } from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import {
  forgotPasswordReducer,
  sendHelpMessageReducer,
  updateProfileReducer,
  userLoginReducer,
  userProfileReducer,
  userRegisterReducer,
} from "./reducers/userReducer";

// COMBINE ALL REDUCERS
const reducer = combineReducers({
  userLogin: userLoginReducer,
  userRegister: userRegisterReducer,
  profile: userProfileReducer,
  forgotPassword: forgotPasswordReducer,
  updateProfile: updateProfileReducer,
  profileHelpMessage: sendHelpMessageReducer,
 
});

// INITIAL STATE
// const initialState = {
//   userLogin: {
//     userInfo: userFromLocalStorage,
//   },
// };

// MIDDLEWARE // THUNK
const middleware = [thunk];

const store = createStore(
  reducer,
  {},
  composeWithDevTools(applyMiddleware(...middleware))
);

export default store;
